import PropTypes from 'prop-types'
import Select from '../../ui/Select'

const Estado = ({ value, onChange }) => {
  const estado = [
    { idPublicacionEstado: 2, nombre: 'Publicada' },
    { idPublicacionEstado: 3, nombre: 'Pausada' }
  ]

  return (
    <div className="row">
      <div className="col">
        Cambiar estado a: &nbsp;
        <Select
          name="idPublicacionEstado"
          onChange={(e) => onChange(e, 'num')}
          value={value}
          className="select-publicacion-chico"
          datos={estado}
          optionMetaDatos={{ value: 'idPublicacionEstado', text: 'nombre' }}
        />
      </div>
    </div>
  )
}

Estado.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
}

export default Estado
